import { render, staticRenderFns } from "./GroupTeamsItem.vue?vue&type=template&id=0f6a3646&"
import script from "./GroupTeamsItem.vue?vue&type=script&lang=js&"
export * from "./GroupTeamsItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupTeamsItem.vue?vue&type=style&index=0&id=0f6a3646&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports